export enum MessageTypeEnum {
  OnLoad = 'on_load',
  InitFormConfig = 'initial',
  SubmitFormData = 'submit_form_data',
}
